import $http from '@/module/http';

export default {
  strict: true,
  namespaced: true,
  state: {
    productDetail: {}
  },
  mutations: {
    setProductDetail(state, payload) {
      state.productDetail = payload;
    },
    setFeatureOptions(state, payload) {
      state.featureOptions = payload;
    }
  },
  actions: {
    getProductDetail({ commit }, payload) {
      return $http
        .get(`products/${payload.productId}/`)
        .then((res) => {
          commit('setProductDetail', res);
          return res;
        })
        .catch((e) => {
          return Promise.reject(e.detail);
        });
    }
  }
};
